import { useLocation, matchPath, } from 'react-router';
import * as H from 'history';

export type RenderToArgument = string | object | ((location: string) => string) | ((location: H.Location<H.LocationState>) => H.LocationDescriptor<H.LocationState>) | H.LocationDescriptor<H.LocationState>;
export type RenderMatchArgument = {} | boolean | null;
export type MatchPathRenderProp = (to: RenderToArgument, match: RenderMatchArgument) => JSX.Element

type MatchPathProps = {
    render: MatchPathRenderProp,
    to: H.LocationDescriptor<H.LocationState> | ((location: H.Location<H.LocationState>) => H.LocationDescriptor<H.LocationState>),
    exact ?: boolean,
    strict?: boolean,
    isActive?: Function
}

const MatchPath = ({ render, to, exact, strict, isActive }: MatchPathProps): JSX.Element => {
    const location = useLocation();
    const url: H.LocationDescriptor<H.LocationState> = (to instanceof Function)
        ? (to as ((location: H.Location<H.LocationState>) => H.LocationDescriptor<H.LocationState>))(location)
        : (to as H.LocationDescriptor<H.LocationState>)

    const match: {} | null = matchPath(location.pathname, {
        path: ((url as H.LocationDescriptorObject<H.LocationState>).pathname ?? url) as string,
        exact: exact,
        strict: strict
    });

    return render( to, (isActive) ? isActive(match, location):match);
}

export default MatchPath;